import PROFILE_ROUTES from '@/presentation/modules/profile/constants/routes';

const profileRoutes = [
	{
		name: PROFILE_ROUTES.profile.name,
		path: PROFILE_ROUTES.profile.path,
		meta: PROFILE_ROUTES.profile.meta,
		component: PROFILE_ROUTES.profile.component,
		children: [
			{
				name: PROFILE_ROUTES.profileShop.name,
				path: PROFILE_ROUTES.profileShop.path,
				meta: PROFILE_ROUTES.profileShop.meta,
				component: PROFILE_ROUTES.profileShop.component,
			},
			{
				name: PROFILE_ROUTES.profilePost.name,
				path: PROFILE_ROUTES.profilePost.path,
				meta: PROFILE_ROUTES.profilePost.meta,
				component: PROFILE_ROUTES.profilePost.component,
			},
			{
				name: PROFILE_ROUTES.profileSetting.name,
				path: PROFILE_ROUTES.profileSetting.path,
				meta: PROFILE_ROUTES.profileSetting.meta,
				component: PROFILE_ROUTES.profileSetting.component,
			},
			{
				name: PROFILE_ROUTES.profileCreatePost.name,
				path: PROFILE_ROUTES.profileCreatePost.path,
				meta: PROFILE_ROUTES.profileCreatePost.meta,
				component: PROFILE_ROUTES.profileCreatePost.component,
			},
			{
				name: PROFILE_ROUTES.profileArtist.name,
				path: PROFILE_ROUTES.profileArtist.path,
				meta: PROFILE_ROUTES.profileArtist.meta,
				component: PROFILE_ROUTES.profileArtist.component,
			},
			{
				name: PROFILE_ROUTES.profileService.name,
				path: PROFILE_ROUTES.profileService.path,
				meta: PROFILE_ROUTES.profileService.meta,
				component: PROFILE_ROUTES.profileService.component,
			},
			{
				name: PROFILE_ROUTES.profileChooseTime.name,
				path: PROFILE_ROUTES.profileChooseTime.path,
				meta: PROFILE_ROUTES.profileChooseTime.meta,
				component: PROFILE_ROUTES.profileChooseTime.component,
			},
		],
	},
];

export default profileRoutes;
